import { render, staticRenderFns } from "./ConteudoVideo.vue?vue&type=template&id=a122e88c&scoped=true&"
import script from "./ConteudoVideo.vue?vue&type=script&lang=js&"
export * from "./ConteudoVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a122e88c",
  null
  
)

export default component.exports